<template>
	<div class="navbar navbar-expand-lg navbar-light footer-adaptive">
		<div class="navbar-collapse collapse">
			<div class="navbar-text">
				&copy; 2026 DevaresStationar
			</div>
			<div class="version d-none d-md-block">Версия:
				<span>{{ state.constants.version }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import stateStore from "@/store";

export default {
	setup() {
		const { state } = stateStore;

		return {
			state
		}
	}
}
</script>

<style scoped>
.navbar-collapse.collapse {
	justify-content: space-between;
}

.navbar-text {
	padding: 0.45rem 0;
	font-size: 0.8125rem;
}

.footer-adaptive {
	border-top: 1px solid var(--dv-border, #d4e0dd);
	background-color: var(--dv-surface, #fff);
	color: var(--dv-text-muted, #5a6e72);
	min-height: 2.5rem;
}

@media (max-width: 576px) {
	.footer-adaptive {
		display: none !important;
	}
}

@media (max-width: 768px) {
	.footer-adaptive .navbar-text {
		font-size: 0.8rem;
		padding: 0.3rem 0;
	}

	.footer-adaptive .version {
		font-size: 0.75rem;
	}
}
</style>